export enum OddsHistoryQueryKeys {
  Movements = "odds-history-movements",
  MatchTimeline = "odds-history-match-timeline",
  MatchSearch = "odds-history-match-search",
  Markets = "odds-history-markets",
}
